import { _get, _post, rootUrl } from "../Api";
import { toast } from "react-toastify";
import axios from "axios";

export function getAllergens(merchantId) {
  return _get(`/nova/v2/allergens/${merchantId}`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateAllergen(merchantId, allergen, newData, oldValues) {
  return updateAllergens(merchantId, [allergen], [newData], [oldValues]).then((allergens) => {
    return Promise.resolve(allergens[0]);
  });
}

export function updateAllergens(merchantId, allergens, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in allergens) {
    if (allergens[i]) {
      data.push({
        allergenId: allergens[i].id,
        ...newData[i],
      });
    } else {
      data.push({
        ...newData[i],
      });
    }
  }
  return _post(`/nova/v2/allergens/${merchantId}/update`, data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}

export function updateAllergenImage(merchantId, allergenId, image) {
  let bodyFormData = new FormData();
  bodyFormData.set("merchantId", merchantId);
  bodyFormData.set("allergenId", allergenId);
  bodyFormData.set("image", image);
  return axios
    .post(rootUrl + "/nova/v2/allergens/" + merchantId + "/allergen/" + allergenId + "/image", bodyFormData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      toast.success("Opgeslagen!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(response.data);
    })
    .catch((e) => {
      console.log(e);
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}
